<template>
   <router-view  :key="$route.fullPath"/>
   

</template>
<script>

export default {
  mounted() {
        const basePicURL = "http://192.168.2.208:8000";

        return basePicURL;
  }
}
</script>
<style>
@import "@/assets/layout.css";
@import '@/assets/css/pannellium-2.5.css';
@import '@/assets/css/video-js.css';
.txtdata {
  margin-top: -200px;
  padding-left: 100px;
  background-color: #003;
  opacity: 0.48;
  color: white;
  border-bottom-right-radius: 70px;
  border-top-right-radius: 70px;
  padding-top: 5px;
  padding-bottom: 5px;
  line-height: 1.2;
 }

/*
.gradient-text {
  font-weight: bold;
  font-size: 40px;
  text-align: center;
  display: block;
  cursor: pointer;
  word-wrap: break-word;         
  overflow-wrap: break-word;     
  width: 40%;
}
.gradient-text:hover{
  animation: rainbow-text-simple-animation 0.5s ease-in forwards;
}*/
 /* Animation shown when entering the page and after the hover animation. */
/*
  .gradient-text {

    background-color: white;
 
     background-image: linear-gradient(
          45deg,
          #f4f3f7 16.666%, 
          #bab9bd 16.666%, 
          #a1be7b 33.333%, 
          #949c19 33.333%, 
          #c2e0aa 50%, 
          #e0e09a 50%, 
          #909e6d 66.666%, 
          #a3be7a 66.666%, 
          #a0d398 83.333%, 
          #bae79c 83.333%);
    

    background-size: 100%;
    background-repeat: repeat;
  

    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent; 
    

      animation: rainbow-text-simple-animation-rev 0.75s ease forwards;
  
  }
  */
  @keyframes rainbow-text-simple-animation-rev {
    0% {
        background-size: 650%;
    }
    40% {
        background-size: 650%;
    }
    100% {
        background-size: 100%;
    }
    }
  #panorama {
    width: 100%;
    height:  556px;
    background-size: cover;
    background-image: linear-gradient(to top, #003, transparent);
    /*-webkit-filter: blur(2px); 
    filter: blur(2px);/* Safari 6.0 - 9.0 */
  }

  .section1 {
    height: 190px;
    background-image: linear-gradient(to top, grey, transparent);
    margin-top: 20px;
    opacity: .9;
  }

  .section02 {
    height: 190px;
    background-image: linear-gradient(to top, grey, transparent);
    margin-top: 20px;
    opacity: .9;
  }

.transition {
  margin-top: 20px;
  background-color: #003;
   transition: all 3s ease-out;
   animation: fadeInAnimation ease 3s;
   animation-iteration-count: 1;
   animation-fill-mode: backwards;
 }

 .videosection {
  margin-top: -60px;
  height: 500px;
}
.boxes .container {
  display: flex;
  justify-content: space-between;
}

.box {
  flex: 1;
  background: #0a51cc;
  color: white;
  border-radius: 10px;
  margin: 20px 20px;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.6);
  padding: 15px 20px;
}
.navbarsection {
  background-image: linear-gradient(to top, #003, transparent);
}

@media only screen and (max-width: 550px) {
  .container {
      grid-template-columns: 1fr;
      grid-template-rows: .2fr 1.2fr .2fr;
      grid-template-areas:
      "nav"
      "main"
      "footer";
  }

}
@media(max-width: 768px){
  .boxes .container {
      display: flex;
      flex-direction: row;
      text-align: center;
  }
  .container .box {
    display: block;
    text-align: center;
}
.txtdata {
  width: 1000px;
  margin-top: -200px;
  padding-left: 100px;

 }
}
</style>
